import { featureIcons } from '@/components/Menu/featureicons';
import { getEnsureLoadedLoader } from './loaderHelper';

export const useEventImplementationsLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('EventImplementations'), 'eventimplementations.loading', '');
};
